// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SecurityField_field__rB1Oy {\n  display: flex;\n  flex-direction: column; }\n  .SecurityField_field__rB1Oy > span:nth-child(2) {\n    display: flex;\n    grid-gap: 8px;\n    gap: 8px;\n    align-items: center; }\n    .SecurityField_field__rB1Oy > span:nth-child(2) .anticon {\n      position: relative;\n      cursor: pointer; }\n      .SecurityField_field__rB1Oy > span:nth-child(2) .anticon.anticon-eye {\n        top: -2px; }\n", ""]);
// Exports
exports.locals = {
	"field": "SecurityField_field__rB1Oy"
};
module.exports = exports;
